import vipUser from '@api/vip'
import loginApis from '@api/login'

export default {
  namespaced: true,
  state: {
    userName: false,
    isLogin: false,
    isSubAccount: 0, //1 子账号， 0 主账号（已创建子账号）， -1 主账号（未创建过子账号）
    bookSize: {
      bookHeight: null,
      bookWidth: null
    },
    appSize: {
      width: null,
      height: null
    },
    bookScale: 1.41,
    isOrdered: false,
    isStaticBook: false,
    vipInfo: {
      isMember: false,
      authProduct: '免费版',
      endTime: Date.now()
    },
    isChart: true,
    isList: false,
    isBookChart: true,
    isBookList: false
  },
  mutations: {
    UPDATE_USER_NAME(state, name) {
      state.userName = name
    },
    UPDATE_IS_SUB_ACCOUNT(state, isSubAccount) {
      state.isSubAccount = isSubAccount
    },
    UPDATE_BOOK_SIZE(state, size) {
      state.bookSize = size
    },
    UPDATE_APP_SIZE(state, size) {
      state.appSize = size
    },
    UPDATE_BOOK_SCALE(state, scale) {
      state.bookScale = scale
    },
    UPDATE_BOOK_STATUS(state, status) {
      state.isStaticBook = status
    },
    UPDATE_IS_ORDERED(state, val) {
      state.isOrdered = val
    },
    UPDATE_IS_LOGIN(state, val) {
      state.isLogin = val
    },
    UPDATE_VIP_INFO(state, info) {
      state.vipInfo = info
    },
    UPDATE_VIP_RIGHT(state, right) {
      state.vipRight = right
    },
    UPDATE_IS_CHART(state, isChart) {
      state.isChart = isChart
    },
    UPDATE_IS_LIST(state, isList) {
      state.isList = isList
    },
    UPDATE_IS_BOOK_CHART(state, isBookChart) {
      state.isBookChart = isBookChart
    },
    UPDATE_IS_BOOK_LIST(state, isBookList) {
      state.isBookList = isBookList
    }
  },
  actions: {
    login({ commit, getters }) {
      return new Promise((reslove, reject) => {
        const userName = getters.userName
        if (!userName) {
          loginApis.login().then((res) => {
            if (res && res.data && res.status === 200) {
              let data = res.data
              if (data.code === 101) {
                localStorage.setItem('username', '')
                commit('UPDATE_IS_SUB_ACCOUNT', 0)
                commit('UPDATE_USER_NAME', false)
                commit('UPDATE_IS_LOGIN', false)
                window.location.href = data.data
              } else {
                localStorage.setItem('username', data.data.username)
                localStorage.setItem('isChild', data.data.isChild)
                commit('UPDATE_IS_SUB_ACCOUNT', data.data.isChild)
                commit('UPDATE_USER_NAME', data.data.username)
                commit('UPDATE_IS_LOGIN', true)
                reslove(true)
              }
            }
          })
        } else {
          reslove(true)
        }
      })
    }
  },
  getters: {
    // 获取本地用户名信息
    userName: (state) => {
      return state.userName || localStorage.getItem('username')
    },
    isSubAccount: (state) => {
      return Math.max(state.isSubAccount, localStorage.getItem('isChild'))
    }
  }
}
